import { render } from "./GamePlay.vue?vue&type=template&id=1f726ac1&scoped=true"
import script from "./GamePlay.vue?vue&type=script&lang=js"
export * from "./GamePlay.vue?vue&type=script&lang=js"

import "./GamePlay.vue?vue&type=style&index=0&id=1f726ac1&lang=less&scoped=true"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f726ac1"]])

export default __exports__